import * as React from "react";
import * as ReactDom from "react-dom";

import { CompactSearch } from "./CompactSearch.react";

export default function main(el: HTMLElement) {
	const applicationRoot = el.querySelector("[data-select=compactSearchRoot]");
	const applicationData = JSON.parse(el.querySelector("script[data-select=applicationCompactSearchData]")?.textContent ?? "");

	if (applicationRoot && applicationData['searchEndpointUri']) {
		ReactDom.render(
			React.createElement(
				CompactSearch,
				{
					searchEndpointUri: applicationData['searchEndpointUri']
				}
			),
			applicationRoot
		);
	}
}
